<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="1200">
      <custom-modal
        title="Transfer Stock"
        @onClose="close"
        :isLoading="true"
        :showSave="false"
      >
        <v-data-table
          :fixed-header="true"
          :headers="columns"
          :items="productList"
          item-key="id"
          disable-pagination
          hide-default-footer
          class="row-pointer product-list"
          expand
          dense
        >
          <template v-slot:top>
            <v-toolbar
              flat
              class="pb-6"
              style="align-items: baseline !important"
            >
              <strong>Warehouse : </strong
              ><v-chip class="ml-4" label>{{
                productList[0].warehouse.name
              }}</v-chip>
              <v-spacer></v-spacer>

              <strong>Kitchen : </strong>
              <v-chip class="ml-4" label>
                {{ productList[0].kitchen.name }}</v-chip
              >
              <v-spacer></v-spacer>
              <div class="d-flex" style="align-items: baseline !important">
                <strong>Status : </strong>

                <v-chip v-if="!isUpdateStatus" class="ml-4" label>
                  {{ transfer.status }}</v-chip
                >
                <v-select
                  v-if="isUpdateStatus"
                  item-text="text"
                  item-value="value"
                  :items="status"
                  v-model="selectedStatus"
                  outlined
                  dense
                  @change="onChangeStatus"
                >
                </v-select>

                <v-tooltip bottom v-if="!isUpdateStatus && isEditable">
                  <template v-slot:activator="{ on, attrs }">
                    <a
                      class="btn btn-sm bg-success-light"
                      dense
                      @click.stop="isUpdateStatus = !isUpdateStatus"
                      link
                      :v-model="isUpdateStatus"
                    >
                      <span>
                        <v-icon class="icon" v-bind="attrs" v-on="on"
                          >mdi-pencil-box-outline</v-icon
                        >
                      </span>
                    </a>
                  </template>
                  <span>Update Status</span>
                </v-tooltip>

                <v-btn
                  :disabled="!isStatusChanged"
                  v-if="isUpdateStatus"
                  depressed
                  small
                  class="text-white btn_blue w-100 mx-1"
                  @click="updateStatus()"
                  :loading="isLoading"
                  >Update</v-btn
                >

                <v-btn
                  v-if="isUpdateStatus"
                  depressed
                  small
                  class="text-white btn_gray w-100 mx-1"
                  @click="isUpdateStatus = false"
                  :loading="isLoading"
                  >Cancel</v-btn
                >
              </div>
              <!-- <span v-if="isUpdateStatus">
                <v-icon v-bind="attrs" v-on="on" @click="isUpdateStatus = false"
                  >mdi-pencil-box-outline</v-icon
                >
              </span> -->
            </v-toolbar>
          </template>

          <template v-slot:item.available="{ item }">
            {{ item.quantity }}
          </template>

          <template v-slot:item.selectedUnit="{ item }">
            {{ item.selectedUnit.name }}
          </template>

          <template v-slot:item.transferedQty="{ item }">
            {{ item.transferQuantity }}
          </template>
        </v-data-table>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "@/plugins/axios";

import { ProductBatch } from "../../../models/ProductBatch";
import datePickComponent from "../../../components/base/DateComponent";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import * as moment from "moment/moment";

export default {
  data: () => ({
    isUpdateStatus: false,
    isEditable: false,
    isStatusChanged: false,
    transfer: null,
    status: [
      { text: "Pending", value: "Pending" },
      { text: "Completed", value: "Completed" },
      { text: "Canceled", value: "Canceled" },
    ],
    units: [],
    slectedKitchen: null,
    kitchens: [],
    searchKitchen: null,
    kitchenError: [],
    kitchenLoading: false,
    columns: [
      {
        text: "Product Name",
        value: "product.name",
        show: true,
        disabled: true,
        align: "left",
        width: "14.2%",
      },
      {
        text: "Batch Name",
        value: "batch.batch",
        show: true,
        disabled: true,
        align: "left",
        width: "12%",
      },
      {
        text: "Unit",
        value: "unit.name",
        align: "center",
        show: true,
        disabled: false,
        width: "10%",
      },
      {
        text: "Qty",
        value: "available",
        show: true,
        disabled: false,
        align: "center",
        width: "10%",
      },
      {
        text: "Transfering unit",
        value: "selectedUnit",
        show: true,
        disabled: false,
        align: "center",
        width: "14%",
      },
      {
        text: "Transfered Qty",
        value: "transferedQty",
        show: true,
        disabled: false,
        align: "center",
        width: "10%",
      },
      // {
      //   text: "Original selling price",
      //   value: "sellingPrice",
      //   show: true,
      //   disabled: false,
      //   align: "right",
      //   width: "10%",
      // },

      // {
      //   text: "Selling Price",
      //   value: "newSellingPrice",
      //   show: true,
      //   disabled: false,
      //   align: "right",
      //   width: "14%",
      // },
    ],
    dialog: false,
    show: false,

    isLoading: false,
  }),

  name: "AddBatch",
  updated: function () {},
  props: {
    productList: {
      type: Array,
      default: [],
    },
  },
  components: { ValidationProvider, ValidationObserver, datePickComponent },

  created() {},
  methods: {
    onChangeStatus() {
      if (this.selectedStatus == this.transfer.status) {
        this.isStatusChanged = false;
      } else {
        this.isStatusChanged = true;
      }
    },
    updateStatus() {
      
      axios
        .patch(`hms/transfers/${this.transfer.id}/change-status`, {
          status: this.selectedStatus,
        })
        .then((resp) => {
          this.isUpdateStatus = false;
          this.isEditable = false;
          this.$toast.success("Status successfully changed");
          this.getStockTrasfer(this.transfer.id);
        })
        .catch((err) => {});
    },
    close() {
      this.show = false;
      this.$emit("onClose", true);
    },
    openModal(id) {
      this.show = true;
      this.getStockTrasfer(id);
    },

    getStockTrasfer(id) {
      
      axios
        .get(`hms/transfers/${id}`)
        .then((resp) => {
          this.productList = [];
          this.transfer = resp.data;
          this.selectedStatus = this.transfer.status;
          if (this.selectedStatus == "Pending") {
            this.isEditable = true;
          } else {
            this.isEditable = false;
          }
          resp.data.items.forEach((item) => {
            let product = new Object();
            product.product = item.product;
            product.unit = item.unit;
            product.batch = item.batch;
            product.quantity = item.quantity;
            product.transferQuantity = item.transfer_quantity;
            product.selectedUnit = item.transferUnit;
            product.sellingPrice = item.sellingPrice;
            product.warehouse = resp.data.wareHouse;
            product.kitchen = resp.data.kitchen;
            this.productList.push(product);
          });
          this.onChangeStatus();
        })
        .catch((err) => {});
    },
  },
};
</script>
